import { type RuntimeConfig } from '@Types/runtimeConfig'

declare const PUBLIC_RUNTIME_CONFIG: RuntimeConfig

export const externalWidgetPublicRuntimeConfig: RuntimeConfig = { ...PUBLIC_RUNTIME_CONFIG }
